import { fmtInt } from '../shared/formatters'

export const buildBrandBreakdown = ({ data, monthKeys, field }) => {
  if (!data.some(d => d.brandName != null)) return null;

  const byMonth = new Map(monthKeys.map(key => [key, new Map()]));

  for (const d of data) {
    if (d.brandName == null) continue;
    const key = `${d.year}-${String(d.month).padStart(2, '0')}`;
    const brands = byMonth.get(key);
    if (!brands) continue;
    const value = d[field] != null ? parseFloat(d[field]) : null;
    if (value == null || isNaN(value)) continue;
    brands.set(d.brandName, (brands.get(d.brandName) ?? 0) + value);
  }

  return monthKeys.map(key => {
    const items = [...byMonth.get(key)]
      .filter(([, value]) => value !== 0)
      .map(([label, value]) => ({ label, value, formatted: fmtInt(value) }))
      .sort((a, b) => b.value - a.value);
    return items.length ? items : null;
  });
};